import Class from './Class';
import _tmpl from '../../upi/templates/index';
import ImageService from '@services/ImageService';

export default Class
    .extend( ImageService )
    .extend( {
        /**
         * init(templateName. [, context])
         * @param String : template name stored on global.tmplate object
         * @param Object : context object for callbacks
         */

        _initialized: false,
        _tmpl: false,

        init: function ( tmplName, ctx ) {
            this.whenTemplatesLoaded = this.loadTemplates();

            if ( _tmpl ) {
                this._tmpl = _tmpl;
            }
            if ( typeof tmplName != 'string' ) {
                throw new TypeError( 'upi.View: "tmpl" id must be a string' );
            }

            if ( typeof ctx != 'object' ) {
                ctx = this;
            }

            this.tmplName = tmplName;
            this.ctx = ctx;
        },

        render: function ( data ) {
            return this.create( this._tmpl[this.tmplName], data );
        },
        loadTemplates: function () {
            return new Promise( ( resolve, reject ) => {
                // already loaded send tmpl data
                if ( this._initialized ) {
                    return resolve( this._tmpl );
                }

                if ( _tmpl ) {
                    this._tmpl = _tmpl.default;
                    this._initialized = true;
                    return resolve( this._tmpl );
                }
                else {
                    return reject( this );
                }
            } );
        },

        // loadTemplates: function () {
        //     var dfd = $.Deferred();
        //
        //     // already loaded send tmpl data
        //     if ( this._initialized ) {
        //         dfd.resolve.call( this, this._tmpl );
        //         return dfd;
        //     }
        //
        //     if ( _tmpl ) {
        //         this._tmpl = _tmpl.default;
        //         this._initialized = true;
        //         dfd.resolve.call( this, _tmpl.default );
        //     }
        //     else {
        //         dfd.reject.call( this );
        //     }
        //
        //     return dfd;
        // },

        create: (function () {
            var cache = {};
            var err = '';

            return function ( tmpl, data ) {
                // let str = tmpl();
                var str = (typeof tmpl === 'function')
                    ? tmpl()
                    : tmpl;

                try {
                    var func = cache[str];
                    if ( !func ) {
                        var strFunc = 'var p=[],render=function(){p.push.apply(p,arguments);};with(obj){p.push(\'' +
                            str.replace( /[\t\r\n]/g, ' ' )
                                .replace( '<![CDATA[', '' )
                                .replace( ']]>', '' )
                                .replace( /'(?![^%]*%>)/g, '\\\'' )
                                .replace( /<%=(.+?)%>/g, '\',$1,\'' )
                                .split( '<%' )
                                .join( '\');' )
                                .split( '%>' )
                                .join( 'p.push(\'' ) +
                            '\');}return p.join(\'\');';
                        //alert(strFunc);
                        func = new Function( 'obj', strFunc );
                        cache[str] = func;
                    }
                    return func.call( this, data );
                }
                catch ( e ) {
                    err = e.message;
                    if ( typeof console !== 'undefined' ) {
                        console.error( 'ERROR: upi.View.create: ' + err );
                        return null;
                    }
                }

            };
        })()

    } );
